import React from "react";
import Typography from "@mui/material/Typography";
import emptyIcon from "@assets/icons/empty.svg";
import { Trans, useTranslation } from "react-i18next";

interface NoEntriesProps {
  noMargin?: boolean;
  dataName: string;
  actionName: string;
  customMessagePrefix?: string;
  descriptionComponents?: Record<string, React.ReactElement>;
  customMessage?: string;
}

const NoTableEntries: React.FC<NoEntriesProps> = ({
  noMargin = false,
  dataName,
  actionName,
  customMessagePrefix,
  descriptionComponents = {},
  customMessage,
}) => {
  const { t } = useTranslation();
  const messagePrefix = customMessagePrefix ? customMessagePrefix : "common.empty-table.title";
  const spacingClass = noMargin ? "" : "mt-24";
  return (
    <div
      data-testid="no-table-entries-container"
      className={`${spacingClass} flex flex-col items-center justify-center gap-4`}
    >
      <img
        src={emptyIcon}
        alt={t("common.empty-table.alt-text", { dataName })}
        className="w-54 h-54"
      />
      {!customMessage && <Typography variant="h6">{t(messagePrefix, { dataName })}</Typography>}
      {customMessage && (
        <Typography variant="h6">
          <Trans i18nKey={customMessage} components={descriptionComponents} />
        </Typography>
      )}
      {actionName && (
        <Typography variant="body1">
          <Trans
            i18nKey={t("common.empty-table.description", { actionName })}
            components={descriptionComponents}
          />
        </Typography>
      )}
    </div>
  );
};

export default NoTableEntries;
